import React from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NEEDisplayMode } from '../../types/enums';

const StyledTypography = styled(Typography)(() => ({
  fontSize: '0.875rem',
  fontWeight: 500,
}));

interface ChartToggleControlsProps {
  displayMode: NEEDisplayMode;
  onDisplayModeChange: (mode: NEEDisplayMode) => void;
}

const ChartToggleControls: React.FC<ChartToggleControlsProps> = ({
  displayMode,
  onDisplayModeChange,
}) => {
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMode = event.target.checked ? NEEDisplayMode.INTENSITY : NEEDisplayMode.TOTAL;
    onDisplayModeChange(newMode);
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <StyledTypography color={displayMode === NEEDisplayMode.TOTAL ? 'primary' : 'text.secondary'}>
        NEE Total
      </StyledTypography>
      <Switch
        checked={displayMode === NEEDisplayMode.INTENSITY}
        onChange={handleToggleChange}
        size="small"
      />
      <StyledTypography color={displayMode === NEEDisplayMode.INTENSITY ? 'primary' : 'text.secondary'}>
        NEE Intensity
      </StyledTypography>
    </Stack>
  );
};

export default ChartToggleControls;
